export default __webpack_public_path__ + "static/media/thumbnail3.6b68eade.jpg";